import { useCallback, useState } from "react";

type ReturnType = {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
};

const useDisclosure = (defaultOpen = false): ReturnType => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const close = useCallback(() => setIsOpen(false), []);

  const open = useCallback(() => setIsOpen(true), []);

  const toggle = useCallback(() => setIsOpen((state) => !state), []);

  return { isOpen, toggle, open, close };
};

export { useDisclosure };
